// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #121212;
  color: #e0e0e0;
  font-family: sans-serif;
  overflow-x: hidden;
}

.App-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.App-header {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  border-bottom: 1px solid #333;
}

.App-logo {
  height: 100px;
  margin-right: 20px;
}

.App-header h1 {
  font-size: 1.5em;
  margin: 0;
}

.App {
  display: flex;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

.left-panel {
  width: 30%;
  padding: 20px;
  border-right: 1px solid #333;
  padding-bottom: 80px;
  max-width: 400px;
}

.right-panel {
  width: 70%;
  padding: 20px;
  padding-bottom: 80px;
}

.section {
  background-color: #1e1e1e;
  border: 1px solid #333;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}

h1,
h2,
h3 {
  color: #ffffff;
}

.search-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.search-input-container input {
  padding-right: 30px;
}

.clear-input-button {
  position: absolute;
  top: 50%;
  right: 5px;
  transform: translateY(-50%);
  background-color: transparent;
  border: none;
  color: #aaa;
  cursor: pointer;
  padding: 0px;
  margin: 0px;
}

.clear-input-button:hover {
  color: #fff;
}

input[type='text'],
input[type='number'],
input[type='password'],
select {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  box-sizing: border-box;
  background-color: #333;
  color: #e0e0e0;
  border: 1px solid #555;
  border-radius: 5px;
}

button {
  background-color: #2196F3;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 10px;
  transition: filter 0.2s ease-in-out;
  display: flex;
  align-items: center;
}

button:hover {
  filter: brightness(90%);
}

.recipe-list {
  text-align: left;
  margin: 10px 0;
}

.recipe-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #333;
  cursor: pointer;
}

.mealplan-item.selected,
.recipe-item.selected {
  border-left: 3px solid #2196F3;
}

.recipe-item:hover {
  background-color: #2c2c2c;
}

.ingredients-list,
.possible-recipes {
  text-align: left;
  margin-top: 10px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin: 5px 0;
  padding: 5px;
  background-color: #2c2c2c;
  border-radius: 3px;
}

.possible-recipe-item {
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #333;
}

.possible-recipe-item:last-child {
  border-bottom: none;
}

.missing-ingredients {
  margin-top: 0.5rem;
  font-size: 0.9rem;
}

.missing-ingredients span {
  color: #aaa;
  margin-right: 0.5rem;
}

.missing-ingredient-button {
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 2px 6px;
  margin-right: 5px;
  margin-bottom: 5px;
  cursor: pointer;
  font-size: 0.8rem;
}

.all-ingredients-present span {
  color: #4CAF50;
}

.additional-items {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.ingredient-input {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: #1e1e1e;
  border-radius: 5px;
  width: 500px;
  max-width: 90%;
  max-height: 90vh;
  /* Reverted to original */
  display: flex;
  flex-direction: column;
}

.filter-modal-content {
  min-height: 250px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #333;
  padding: 20px 20px 10px 20px;
  margin-bottom: 0;
  flex-shrink: 0;
}

.modal-body {
  overflow-y: auto;
  padding: 10px 20px;
  flex-grow: 1;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #333;
  padding: 10px 20px 20px 20px;
  margin-top: 0;
  flex-shrink: 0;
}

.cookbook-modal .clear-input-button,
.recipe-modal .recipe-name-container .clear-input-button {
  right: 50px;
}

.close-button {
  color: #f44336;
}

.close-button:hover {
  color: #da190b;
}

.icon-button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 5px;
  color: #e0e0e0;
  transition: color 0.2s ease-in-out;
}

.icon-button:hover {
  color: #b0b0b0;
}

.cancel-button {
  background-color: #da190b;
  color: white;
}

.delete-button {
  color: #f44336;
}

.delete-button:hover {
  color: #da190b;
}

.ingredients-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.plus-button {
  background-color: #2196F3;
  color: white;
  border: none;
  height: 30px;
  font-size: 1.5rem;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  padding: 2px 0 0 0;
}

.plus-button:hover {
  filter: brightness(90%);
}

.plus-button i {
  margin: 0;
}

.section-header .plus-button {
  margin-left: 5px;
  margin-right: 0px;
}

.cookbook-form {
  display: flex;
  margin-bottom: 10px;
}

.cookbook-list li.selected {
  border-left: 3px solid #2196F3;
}

.cookbook-list li,
.mealplan-list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.recipe-info {
  display: flex;
  flex-direction: column;
  width: 70%;
}

.recipe-name {
  display: flex;
  align-items: center;
}

.recipe-name span {
  margin-left: 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.recipe-details {
  font-size: 0.8rem;
  color: #aaa;
  margin-left: 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.collapsible-section .section-header:hover {
  background-color: #2c2c2c;
}

.collapsible-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.cookbook-filter-list {
  display: flex;
  flex-direction: column;
}

.cookbook-filter-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.filter-active {
  color: #2196F3;
}

.unselect-button {
  background-color: transparent;
  border: 1px solid #f44336;
  color: #f44336;
  padding: 2px 5px;
  font-size: 0.8rem;
  margin-right: 10px;
}

.unselect-button:hover {
  background-color: #f44336;
  color: white;
}

.clear-filter-button {
  background-color: transparent;
  border: 1px solid #f44336;
  color: #f44336;
  padding: 2px 5px;
  font-size: 0.8rem;
  margin-left: 10px;
}

.clear-filter-button:hover {
  background-color: #f44336;
  color: white;
}

.recipe-filter-controls {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.recipe-actions,
.item-actions {
  display: flex;
  visibility: hidden;
}

.meal-plan-title-container,
.find-recipes-by-ingredients-title-container {
  display: flex;
  align-items: center;
}

.meal-plan-recipe {
  cursor: grab;
}

.meal-plan-recipe:active {
  cursor: grabbing;
}

.move-recipe-buttons {
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  visibility: hidden;
}

.meal-plan-recipe:hover .move-recipe-buttons {
  visibility: visible;
}

.recipe-item:hover .recipe-actions,
.cookbook-list li:hover .item-actions,
.category-list li:hover .item-actions,
.mealplan-list li:hover .item-actions,
.meal-plan-title-container:hover .item-actions,
.meal-plan-recipe:hover .item-actions,
.additional-item:hover .item-actions,
.shopping-list-panel li:hover .item-actions {
  visibility: visible;
}

.additional-item {
  border-bottom: 1px solid #333;
}

.checkbox-container {
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.3s ease-in-out, width 0.3s ease-in-out;
  opacity: 1;
}

.checkbox-container.hidden {
  opacity: 0;
  width: 0;
  display: none;
}

.search-input-container {
  transition: margin-left 0.3s ease-in-out;
  flex: 1 1 auto;
}

.search-input-container.expanded {
  margin-left: 0;
}

.search-input-container.collapsed {
  margin-left: 1rem;
}

.recipe-list-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 325px;
}

.recipe-list {
  flex-grow: 1;
}

.pagination-controls {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.page-numbers {
  display: flex;
  gap: 5px;
}

.page-numbers button {
  background-color: transparent;
  border: 1px solid #555;
  color: #e0e0e0;
  padding: 5px 10px;
}

.page-numbers button.active {
  background-color: #2196F3;
  color: white;
}

.page-numbers button:disabled {
  opacity: 1;
  cursor: default;
}

.recipe-tooltip {
  position: fixed;
  background-color: #333;
  border: 1px solid #555;
  border-radius: 5px;
  padding: 10px;
  z-index: 1002;
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.searchable-dropdown {
  position: relative;
}

.dropdown-list {
  position: absolute;
  top: 75%;
  left: 0;
  right: 0;
  background-color: white;
  border: 1px solid #555;
  border-radius: 5px;
  z-index: 1001;
  max-height: 200px;
  overflow-y: auto;
  color: black;
}

.dropdown-list li {
  cursor: pointer;
  margin: 5px;
  padding: 10px;
  background-color: white;
  border-radius: 3px;
}

.dropdown-list li:hover {
  background-color: #45a049;
  color: white;
}

.selected-items {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.selected-item {
  display: flex;
  align-items: center;
  background-color: #4CAF50;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
}

.remove-item-button {
  background-color: transparent;
  border: none;
  color: white;
  margin-left: 10px;
  margin-right: 0px;
  padding-right: 0px;
  cursor: pointer;
}

.print-button {
  background-color: #4CAF50;
  color: white;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;
  display: flex;
  align-items: center;
}

.print-button i {
  margin-right: 5px;
}

.error-message {
  color: #f44336;
  margin-bottom: 10px;
}

.day-row {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
}

.day-row:last-of-type {
  border-bottom: none;
  margin-bottom: 1rem;
}

.day-label {
  flex: 0 0 80px;
  padding-top: 0.5rem;
}

.day-slot {
  flex-grow: 1;
  border: 2px dashed #333;
  border-radius: 5px;
  padding: 10px;
  min-height: 50px;
  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
}

.day-slot.is-over {
  background-color: #2c2c2c;
  border-color: #2196F3;
}

.recipe-list-day {
  padding: 0;
  margin: 0;
  list-style-type: none;
}

.empty-day-placeholder {
  color: #aaa;
  text-align: center;
  padding: 10px;
}



.back-to-top-button {
  position: fixed;
  bottom: 80px;
  right: 10px;
  background-color: #2196F3;
  color: white;
  border: none;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1001;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  opacity: 0;
  visibility: hidden;
  transform: translateY(100px);
  transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease-in-out;
}

@keyframes pulse-glow {
  0% {
    box-shadow: 0 0 0 0 rgba(33, 150, 243, 0.7);
  }

  100% {
    box-shadow: 0 0 10px 5px rgba(255, 255, 255, 0.3);
  }
}

.back-to-top-button.visible {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.back-to-top-button>i {
  margin-right: 0px;
}

.ingredients-container {
  display: flex;
  gap: 1rem;
}

.ingredient-list-panel,
.shopping-list-panel {
  flex: 1 1;
  background-color: #1e1e1e;
  padding: 1rem;
  border-radius: 5px;
  min-height: 200px;
  display: flex;
  flex-direction: column;
}

.shopping-list-panel ul {
  padding-left: 0;
}

.ingredient-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #333;
  cursor: pointer;
}

.ingredient-item:hover {
  background-color: #2c2c2c;
}

.ingredient-item.selected span {
  text-decoration: line-through;
  color: #aaa;
}

.filter-container {
  display: flex;
  gap: 1rem;
}

.filter-section {
  flex: 1 1;
  min-width: 0;
}






.faq-list {
  margin-top: 20px;
}

.faq-item {
  border-bottom: 1px solid #333;
  padding: 10px 0;
}

.faq-question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.faq-answer {
  margin-top: 10px;
}

.faq-item .section-header {
  cursor: pointer;
}

.modal-header h2 .material-icons {
  vertical-align: middle;
  margin-right: 10px;
}

.save-button:hover i {
  color: #4CAF50;
}

/* Light Theme */

.camera-container {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
  background-color: #000;
  border-radius: 8px;
  overflow: hidden;
}

.camera-video {
  max-width: 100%;
  max-height: 300px;
  width: auto;
  height: auto;
}

body.light-theme {
  background-color: #ffffff;
  color: #212529;
}

.light-theme .section,
.light-theme .modal-content,
.light-theme .mobile-menu {
  background-color: #f8f9fa;
  border-color: #dee2e6;
}

.light-theme h1,
.light-theme h2,
.light-theme h3 {
  color: #212529;
}

.light-theme input[type='text'],
.light-theme input[type='number'],
.light-theme input[type='password'],
.light-theme select {
  background-color: #ffffff;
  color: #212529;
  border-color: #ced4da;
}

.light-theme li {
  background-color: #f8f9fa;
}

.light-theme .recipe-item:hover,
.light-theme .collapsible-section .section-header:hover {
  background-color: #e9ecef;
}

.light-theme .icon-button {
  color: #212529;
}

.light-theme .icon-button:hover {
  color: #000000;
}

.light-theme .delete-button {
  color: #dc3545;
}

.light-theme .delete-button:hover {
  color: #c82333;
}

.light-theme .day-slot {
  border-color: #dee2e6;
}

.light-theme .day-slot.is-over {
  background-color: #e9ecef;
  border-color: #007bff;
}

.light-theme .recipe-item.selected {
  border-left-color: #007bff;
}

.light-theme .App-header {
  border-bottom-color: #dee2e6;
}

.light-theme .left-panel {
  border-right-color: #dee2e6;
}

.light-theme .footer-toolbar {
  background-color: #f8f9fa;
}

.theme-switcher {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
}

.light-theme-button {
  background-color: #ffffff;
  color: #212529;
  border: 1px solid #ced4da;
}

.dark-theme-button {
  background-color: #333;
  color: #e0e0e0;
  border: 1px solid #555;
}

.light-theme .recipe-tooltip,
.light-theme .recipe-tooltip li {
  background-color: #e9ecef;
  border-color: #dee2e6;
  color: #212529;
}

.light-theme .login-form,
.light-theme .register-form {
  background-color: #f8f9fa;
}

.light-theme .ingredient-item:hover {
  background-color: #e9ecef;
}

.ingredient-tooltip {
  position: fixed;
  background-color: #333;
  border: 1px solid #555;
  border-radius: 5px;
  padding: 10px;
  z-index: 1002;
  color: #e0e0e0;
}

.light-theme .ingredient-tooltip {
  background-color: #e9ecef;
  border-color: #dee2e6;
  color: #212529;
}

/* Append this to your App.css file */

.header-right {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.header-user-info {
  display: flex;
  align-items: center;
}

.header-user-info span {
  margin-right: 20px;
}

.header-user-info button i {
  margin-right: 5px;
}

/* Hamburger Menu */
.hamburger-menu-icon {
  display: none;
  /* Hidden by default */
  cursor: pointer;
  padding: 0.5rem;
}

.hamburger-menu-icon .material-icons {
  font-size: 2rem;
  color: var(--header-text-color);
}

.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  /* Higher than modals */
  display: flex;
  justify-content: flex-end;
}

.mobile-menu {
  width: 280px;
  height: 100%;
  background-color: #1e1e1e;
  color: var(--text-color);
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  animation: slideIn 0.3s ease-out forwards;
}

.mobile-menu-items button {
  width: 100%;
  border: none;
  border-radius: 0px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.mobile-menu-items button i {
  margin-right: 5px;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0);
  }
}

.mobile-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid var(--border-color);
  font-weight: bold;
}

.close-mobile-menu {
  background: none;
  border: none;
  color: var(--text-color);
  cursor: pointer;
  padding: 0;
}

.mobile-menu-content {
  display: flex;
  flex-direction: column;
  padding: 1rem;
}

.mobile-menu-content .button {
  display: flex;
  align-items: center;
  text-align: left;
  width: 100%;
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
  justify-content: flex-start;
}

.mobile-menu-content .button .material-icons {
  margin-right: 1rem;
}

.recipe-drop-placeholder {
  height: 2rem;
  background-color: #333;
  border: 2px dashed #2196F3;
  margin: 5px 0;
}

.footer-toolbar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #1e1e1e;
  border-top: 1px solid #333;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 15px;
  padding-right: 15px;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transform: translateY(100%);
  transition: transform 0.3s ease-in-out;
}

.footer-toolbar.visible {
  transform: translateY(0);
}

.tour-buttons-footer {
  display: flex;
  gap: 10px;
}

.save-button-container-fixed {
  display: flex;
  align-items: center;
  padding-right: 10px;
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {

  .hide-on-mobile {
    display: none;
  }

  .recipe-actions,
  .item-actions {
    visibility: visible;
  }

  .header-user-info,
  .tour-buttons {
    display: none;
  }

  .hamburger-menu-icon {
    display: block;
  }

  .App {
    flex-direction: column;
  }

  .left-panel,
  .right-panel {
    width: 100%;
    border-right: none;
    padding: 0.5rem;
  }

  .left-panel {
    border-bottom: 1px solid var(--border-color);
    margin-bottom: 1rem;
  }

  .recipe-actions,
  .item-actions,
  .move-recipe-buttons {
    visibility: visible;
  }

  .ingredients-container {
    flex-direction: column;
  }

  .day-row {
    display: block;
  }

  .empty-row-actions {
    visibility: hidden;
  }

  .section-header .plus-button {
    margin-left: 20px;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.spin {
  animation: spin 1s linear infinite;
}

/* Mobile View Button */
.mobile-view-button {
  display: none;
  padding: 0;
  margin-right: 5px;
  color: #aaa;
}

.mobile-view-button:hover {
  color: #fff;
}

@media (max-width: 768px) {
  .mobile-view-button {
    display: inline-flex;
  }
}

/* Tooltip Overlay */
.tooltip-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.recipe-tooltip.mobile-centered {
  position: relative;
  width: 90%;
  max-width: 400px;
  background-color: #333;
  border: 1px solid #555;
  border-radius: 5px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.tooltip-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.close-tooltip-button {
  color: #aaa;
  padding: 0;
}

.close-tooltip-button:hover {
  color: #fff;
}

/* Light Theme Overrides for Mobile Tooltip */
.light-theme .recipe-tooltip.mobile-centered {
  background-color: #f8f9fa;
  border-color: #dee2e6;
  color: #212529;
}

.light-theme .close-tooltip-button {
  color: #6c757d;
}

.light-theme .close-tooltip-button:hover {
  color: #343a40;
}

.dropdown-item-with-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dropdown-item-actions {
  display: flex;
  visibility: hidden;
  gap: 2px;
}

.dropdown-item-with-actions:hover .dropdown-item-actions {
  visibility: visible;
}

.icon-button.small {
  padding: 2px;
  width: 24px;
  height: 24px;
}

.icon-button.small i {
  font-size: 18px;
}

.icon-button.active-green {
  color: #4CAF50;
}

.icon-button.active-blue {
  color: #2196F3;
}

.icon-button.active-red {
  color: #f44336;
}

.filter-modal-container {
  width: 700px;
}

.filter-modal-container ul {
  min-width: 250px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;;EAIE,WAAW;EACX,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;;;EAQE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4DAA4D;EAC5D,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,4EAA4E;AAC9E;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;;;AAIA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,wCAAwC;EACxC,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAC5B,+EAA+E;AACjF;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,iDAAiD;EACnD;AACF;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,SAAO;EACP,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;;;;;;AAOA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;;AAEhB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,qCAAqC;;AAErC;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,wBAAwB;EACxB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;;EAEE;IACE,aAAa;EACf;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,4CAA4C;IAC5C,mBAAmB;EACrB;;EAEA;;;IAGE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA,6CAA6C;AAC7C;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["body {\n  background-color: #121212;\n  color: #e0e0e0;\n  font-family: sans-serif;\n  overflow-x: hidden;\n}\n\n.App-container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n.App-header {\n  display: flex;\n  align-items: center;\n  padding: 10px 20px;\n  border-bottom: 1px solid #333;\n}\n\n.App-logo {\n  height: 100px;\n  margin-right: 20px;\n}\n\n.App-header h1 {\n  font-size: 1.5em;\n  margin: 0;\n}\n\n.App {\n  display: flex;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 20px;\n  box-sizing: border-box;\n}\n\n.left-panel {\n  width: 30%;\n  padding: 20px;\n  border-right: 1px solid #333;\n  padding-bottom: 80px;\n  max-width: 400px;\n}\n\n.right-panel {\n  width: 70%;\n  padding: 20px;\n  padding-bottom: 80px;\n}\n\n.section {\n  background-color: #1e1e1e;\n  border: 1px solid #333;\n  border-radius: 5px;\n  padding: 20px;\n  margin-bottom: 20px;\n}\n\nh1,\nh2,\nh3 {\n  color: #ffffff;\n}\n\n.search-input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.search-input-container input {\n  padding-right: 30px;\n}\n\n.clear-input-button {\n  position: absolute;\n  top: 50%;\n  right: 5px;\n  transform: translateY(-50%);\n  background-color: transparent;\n  border: none;\n  color: #aaa;\n  cursor: pointer;\n  padding: 0px;\n  margin: 0px;\n}\n\n.clear-input-button:hover {\n  color: #fff;\n}\n\ninput[type='text'],\ninput[type='number'],\ninput[type='password'],\nselect {\n  width: 100%;\n  padding: 10px;\n  margin: 10px 0;\n  box-sizing: border-box;\n  background-color: #333;\n  color: #e0e0e0;\n  border: 1px solid #555;\n  border-radius: 5px;\n}\n\nbutton {\n  background-color: #2196F3;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-right: 10px;\n  transition: filter 0.2s ease-in-out;\n  display: flex;\n  align-items: center;\n}\n\nbutton:hover {\n  filter: brightness(90%);\n}\n\n.recipe-list {\n  text-align: left;\n  margin: 10px 0;\n}\n\n.recipe-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  border-bottom: 1px solid #333;\n  cursor: pointer;\n}\n\n.mealplan-item.selected,\n.recipe-item.selected {\n  border-left: 3px solid #2196F3;\n}\n\n.recipe-item:hover {\n  background-color: #2c2c2c;\n}\n\n.ingredients-list,\n.possible-recipes {\n  text-align: left;\n  margin-top: 10px;\n}\n\nul {\n  list-style-type: none;\n  padding: 0;\n}\n\nli {\n  margin: 5px 0;\n  padding: 5px;\n  background-color: #2c2c2c;\n  border-radius: 3px;\n}\n\n.possible-recipe-item {\n  margin-bottom: 1rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #333;\n}\n\n.possible-recipe-item:last-child {\n  border-bottom: none;\n}\n\n.missing-ingredients {\n  margin-top: 0.5rem;\n  font-size: 0.9rem;\n}\n\n.missing-ingredients span {\n  color: #aaa;\n  margin-right: 0.5rem;\n}\n\n.missing-ingredient-button {\n  background-color: #f44336;\n  color: white;\n  border: none;\n  border-radius: 3px;\n  padding: 2px 6px;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  cursor: pointer;\n  font-size: 0.8rem;\n}\n\n.all-ingredients-present span {\n  color: #4CAF50;\n}\n\n.additional-items {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.ingredient-input {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background-color: #1e1e1e;\n  border-radius: 5px;\n  width: 500px;\n  max-width: 90%;\n  max-height: 90vh;\n  /* Reverted to original */\n  display: flex;\n  flex-direction: column;\n}\n\n.filter-modal-content {\n  min-height: 250px;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #333;\n  padding: 20px 20px 10px 20px;\n  margin-bottom: 0;\n  flex-shrink: 0;\n}\n\n.modal-body {\n  overflow-y: auto;\n  padding: 10px 20px;\n  flex-grow: 1;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  border-top: 1px solid #333;\n  padding: 10px 20px 20px 20px;\n  margin-top: 0;\n  flex-shrink: 0;\n}\n\n.cookbook-modal .clear-input-button,\n.recipe-modal .recipe-name-container .clear-input-button {\n  right: 50px;\n}\n\n.close-button {\n  color: #f44336;\n}\n\n.close-button:hover {\n  color: #da190b;\n}\n\n.icon-button {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 5px;\n  color: #e0e0e0;\n  transition: color 0.2s ease-in-out;\n}\n\n.icon-button:hover {\n  color: #b0b0b0;\n}\n\n.cancel-button {\n  background-color: #da190b;\n  color: white;\n}\n\n.delete-button {\n  color: #f44336;\n}\n\n.delete-button:hover {\n  color: #da190b;\n}\n\n.ingredients-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.plus-button {\n  background-color: #2196F3;\n  color: white;\n  border: none;\n  height: 30px;\n  font-size: 1.5rem;\n  line-height: 30px;\n  text-align: center;\n  cursor: pointer;\n  padding: 2px 0 0 0;\n}\n\n.plus-button:hover {\n  filter: brightness(90%);\n}\n\n.plus-button i {\n  margin: 0;\n}\n\n.section-header .plus-button {\n  margin-left: 5px;\n  margin-right: 0px;\n}\n\n.cookbook-form {\n  display: flex;\n  margin-bottom: 10px;\n}\n\n.cookbook-list li.selected {\n  border-left: 3px solid #2196F3;\n}\n\n.cookbook-list li,\n.mealplan-list li {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n}\n\n.recipe-info {\n  display: flex;\n  flex-direction: column;\n  width: 70%;\n}\n\n.recipe-name {\n  display: flex;\n  align-items: center;\n}\n\n.recipe-name span {\n  margin-left: 0px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.recipe-details {\n  font-size: 0.8rem;\n  color: #aaa;\n  margin-left: 0px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.collapsible-section .section-header:hover {\n  background-color: #2c2c2c;\n}\n\n.collapsible-section .section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n}\n\n.cookbook-filter-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.cookbook-filter-item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.filter-active {\n  color: #2196F3;\n}\n\n.unselect-button {\n  background-color: transparent;\n  border: 1px solid #f44336;\n  color: #f44336;\n  padding: 2px 5px;\n  font-size: 0.8rem;\n  margin-right: 10px;\n}\n\n.unselect-button:hover {\n  background-color: #f44336;\n  color: white;\n}\n\n.clear-filter-button {\n  background-color: transparent;\n  border: 1px solid #f44336;\n  color: #f44336;\n  padding: 2px 5px;\n  font-size: 0.8rem;\n  margin-left: 10px;\n}\n\n.clear-filter-button:hover {\n  background-color: #f44336;\n  color: white;\n}\n\n.recipe-filter-controls {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.recipe-actions,\n.item-actions {\n  display: flex;\n  visibility: hidden;\n}\n\n.meal-plan-title-container,\n.find-recipes-by-ingredients-title-container {\n  display: flex;\n  align-items: center;\n}\n\n.meal-plan-recipe {\n  cursor: grab;\n}\n\n.meal-plan-recipe:active {\n  cursor: grabbing;\n}\n\n.move-recipe-buttons {\n  display: flex;\n  flex-direction: column;\n  margin-right: 10px;\n  visibility: hidden;\n}\n\n.meal-plan-recipe:hover .move-recipe-buttons {\n  visibility: visible;\n}\n\n.recipe-item:hover .recipe-actions,\n.cookbook-list li:hover .item-actions,\n.category-list li:hover .item-actions,\n.mealplan-list li:hover .item-actions,\n.meal-plan-title-container:hover .item-actions,\n.meal-plan-recipe:hover .item-actions,\n.additional-item:hover .item-actions,\n.shopping-list-panel li:hover .item-actions {\n  visibility: visible;\n}\n\n.additional-item {\n  border-bottom: 1px solid #333;\n}\n\n.checkbox-container {\n  width: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: opacity 0.3s ease-in-out, width 0.3s ease-in-out;\n  opacity: 1;\n}\n\n.checkbox-container.hidden {\n  opacity: 0;\n  width: 0;\n  display: none;\n}\n\n.search-input-container {\n  transition: margin-left 0.3s ease-in-out;\n  flex: 1 1 auto;\n}\n\n.search-input-container.expanded {\n  margin-left: 0;\n}\n\n.search-input-container.collapsed {\n  margin-left: 1rem;\n}\n\n.recipe-list-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 325px;\n}\n\n.recipe-list {\n  flex-grow: 1;\n}\n\n.pagination-controls {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n\n.page-numbers {\n  display: flex;\n  gap: 5px;\n}\n\n.page-numbers button {\n  background-color: transparent;\n  border: 1px solid #555;\n  color: #e0e0e0;\n  padding: 5px 10px;\n}\n\n.page-numbers button.active {\n  background-color: #2196F3;\n  color: white;\n}\n\n.page-numbers button:disabled {\n  opacity: 1;\n  cursor: default;\n}\n\n.recipe-tooltip {\n  position: fixed;\n  background-color: #333;\n  border: 1px solid #555;\n  border-radius: 5px;\n  padding: 10px;\n  z-index: 1002;\n}\n\nbutton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.searchable-dropdown {\n  position: relative;\n}\n\n.dropdown-list {\n  position: absolute;\n  top: 75%;\n  left: 0;\n  right: 0;\n  background-color: white;\n  border: 1px solid #555;\n  border-radius: 5px;\n  z-index: 1001;\n  max-height: 200px;\n  overflow-y: auto;\n  color: black;\n}\n\n.dropdown-list li {\n  cursor: pointer;\n  margin: 5px;\n  padding: 10px;\n  background-color: white;\n  border-radius: 3px;\n}\n\n.dropdown-list li:hover {\n  background-color: #45a049;\n  color: white;\n}\n\n.selected-items {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.selected-item {\n  display: flex;\n  align-items: center;\n  background-color: #4CAF50;\n  color: white;\n  padding: 5px 10px;\n  border-radius: 5px;\n}\n\n.remove-item-button {\n  background-color: transparent;\n  border: none;\n  color: white;\n  margin-left: 10px;\n  margin-right: 0px;\n  padding-right: 0px;\n  cursor: pointer;\n}\n\n.print-button {\n  background-color: #4CAF50;\n  color: white;\n  padding: 5px 10px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-left: 10px;\n  display: flex;\n  align-items: center;\n}\n\n.print-button i {\n  margin-right: 5px;\n}\n\n.error-message {\n  color: #f44336;\n  margin-bottom: 10px;\n}\n\n.day-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  margin-bottom: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.day-row:last-of-type {\n  border-bottom: none;\n  margin-bottom: 1rem;\n}\n\n.day-label {\n  flex: 0 0 80px;\n  padding-top: 0.5rem;\n}\n\n.day-slot {\n  flex-grow: 1;\n  border: 2px dashed #333;\n  border-radius: 5px;\n  padding: 10px;\n  min-height: 50px;\n  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;\n}\n\n.day-slot.is-over {\n  background-color: #2c2c2c;\n  border-color: #2196F3;\n}\n\n.recipe-list-day {\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n}\n\n.empty-day-placeholder {\n  color: #aaa;\n  text-align: center;\n  padding: 10px;\n}\n\n\n\n.back-to-top-button {\n  position: fixed;\n  bottom: 80px;\n  right: 10px;\n  background-color: #2196F3;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 56px;\n  height: 56px;\n  font-size: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 1001;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(100px);\n  transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease-in-out;\n}\n\n@keyframes pulse-glow {\n  0% {\n    box-shadow: 0 0 0 0 rgba(33, 150, 243, 0.7);\n  }\n\n  100% {\n    box-shadow: 0 0 10px 5px rgba(255, 255, 255, 0.3);\n  }\n}\n\n.back-to-top-button.visible {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.back-to-top-button>i {\n  margin-right: 0px;\n}\n\n.ingredients-container {\n  display: flex;\n  gap: 1rem;\n}\n\n.ingredient-list-panel,\n.shopping-list-panel {\n  flex: 1;\n  background-color: #1e1e1e;\n  padding: 1rem;\n  border-radius: 5px;\n  min-height: 200px;\n  display: flex;\n  flex-direction: column;\n}\n\n.shopping-list-panel ul {\n  padding-left: 0;\n}\n\n.ingredient-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  border-bottom: 1px solid #333;\n  cursor: pointer;\n}\n\n.ingredient-item:hover {\n  background-color: #2c2c2c;\n}\n\n.ingredient-item.selected span {\n  text-decoration: line-through;\n  color: #aaa;\n}\n\n.filter-container {\n  display: flex;\n  gap: 1rem;\n}\n\n.filter-section {\n  flex: 1;\n  min-width: 0;\n}\n\n\n\n\n\n\n.faq-list {\n  margin-top: 20px;\n}\n\n.faq-item {\n  border-bottom: 1px solid #333;\n  padding: 10px 0;\n}\n\n.faq-question {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n}\n\n.faq-answer {\n  margin-top: 10px;\n}\n\n.faq-item .section-header {\n  cursor: pointer;\n}\n\n.modal-header h2 .material-icons {\n  vertical-align: middle;\n  margin-right: 10px;\n}\n\n.save-button:hover i {\n  color: #4CAF50;\n}\n\n/* Light Theme */\n\n.camera-container {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 1rem;\n  background-color: #000;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.camera-video {\n  max-width: 100%;\n  max-height: 300px;\n  width: auto;\n  height: auto;\n}\n\nbody.light-theme {\n  background-color: #ffffff;\n  color: #212529;\n}\n\n.light-theme .section,\n.light-theme .modal-content,\n.light-theme .mobile-menu {\n  background-color: #f8f9fa;\n  border-color: #dee2e6;\n}\n\n.light-theme h1,\n.light-theme h2,\n.light-theme h3 {\n  color: #212529;\n}\n\n.light-theme input[type='text'],\n.light-theme input[type='number'],\n.light-theme input[type='password'],\n.light-theme select {\n  background-color: #ffffff;\n  color: #212529;\n  border-color: #ced4da;\n}\n\n.light-theme li {\n  background-color: #f8f9fa;\n}\n\n.light-theme .recipe-item:hover,\n.light-theme .collapsible-section .section-header:hover {\n  background-color: #e9ecef;\n}\n\n.light-theme .icon-button {\n  color: #212529;\n}\n\n.light-theme .icon-button:hover {\n  color: #000000;\n}\n\n.light-theme .delete-button {\n  color: #dc3545;\n}\n\n.light-theme .delete-button:hover {\n  color: #c82333;\n}\n\n.light-theme .day-slot {\n  border-color: #dee2e6;\n}\n\n.light-theme .day-slot.is-over {\n  background-color: #e9ecef;\n  border-color: #007bff;\n}\n\n.light-theme .recipe-item.selected {\n  border-left-color: #007bff;\n}\n\n.light-theme .App-header {\n  border-bottom-color: #dee2e6;\n}\n\n.light-theme .left-panel {\n  border-right-color: #dee2e6;\n}\n\n.light-theme .footer-toolbar {\n  background-color: #f8f9fa;\n}\n\n.theme-switcher {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 20px 0;\n}\n\n.light-theme-button {\n  background-color: #ffffff;\n  color: #212529;\n  border: 1px solid #ced4da;\n}\n\n.dark-theme-button {\n  background-color: #333;\n  color: #e0e0e0;\n  border: 1px solid #555;\n}\n\n.light-theme .recipe-tooltip,\n.light-theme .recipe-tooltip li {\n  background-color: #e9ecef;\n  border-color: #dee2e6;\n  color: #212529;\n}\n\n.light-theme .login-form,\n.light-theme .register-form {\n  background-color: #f8f9fa;\n}\n\n.light-theme .ingredient-item:hover {\n  background-color: #e9ecef;\n}\n\n.ingredient-tooltip {\n  position: fixed;\n  background-color: #333;\n  border: 1px solid #555;\n  border-radius: 5px;\n  padding: 10px;\n  z-index: 1002;\n  color: #e0e0e0;\n}\n\n.light-theme .ingredient-tooltip {\n  background-color: #e9ecef;\n  border-color: #dee2e6;\n  color: #212529;\n}\n\n/* Append this to your App.css file */\n\n.header-right {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n}\n\n.header-user-info {\n  display: flex;\n  align-items: center;\n}\n\n.header-user-info span {\n  margin-right: 20px;\n}\n\n.header-user-info button i {\n  margin-right: 5px;\n}\n\n/* Hamburger Menu */\n.hamburger-menu-icon {\n  display: none;\n  /* Hidden by default */\n  cursor: pointer;\n  padding: 0.5rem;\n}\n\n.hamburger-menu-icon .material-icons {\n  font-size: 2rem;\n  color: var(--header-text-color);\n}\n\n.mobile-menu-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1050;\n  /* Higher than modals */\n  display: flex;\n  justify-content: flex-end;\n}\n\n.mobile-menu {\n  width: 280px;\n  height: 100%;\n  background-color: #1e1e1e;\n  color: var(--text-color);\n  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n  animation: slideIn 0.3s ease-out forwards;\n}\n\n.mobile-menu-items button {\n  width: 100%;\n  border: none;\n  border-radius: 0px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n.mobile-menu-items button i {\n  margin-right: 5px;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n  }\n\n  to {\n    transform: translateX(0);\n  }\n}\n\n.mobile-menu-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  border-bottom: 1px solid var(--border-color);\n  font-weight: bold;\n}\n\n.close-mobile-menu {\n  background: none;\n  border: none;\n  color: var(--text-color);\n  cursor: pointer;\n  padding: 0;\n}\n\n.mobile-menu-content {\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n}\n\n.mobile-menu-content .button {\n  display: flex;\n  align-items: center;\n  text-align: left;\n  width: 100%;\n  margin-bottom: 1rem;\n  padding: 0.75rem 1rem;\n  justify-content: flex-start;\n}\n\n.mobile-menu-content .button .material-icons {\n  margin-right: 1rem;\n}\n\n.recipe-drop-placeholder {\n  height: 2rem;\n  background-color: #333;\n  border: 2px dashed #2196F3;\n  margin: 5px 0;\n}\n\n.footer-toolbar {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #1e1e1e;\n  border-top: 1px solid #333;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  padding-left: 15px;\n  padding-right: 15px;\n  z-index: 1000;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transform: translateY(100%);\n  transition: transform 0.3s ease-in-out;\n}\n\n.footer-toolbar.visible {\n  transform: translateY(0);\n}\n\n.tour-buttons-footer {\n  display: flex;\n  gap: 10px;\n}\n\n.save-button-container-fixed {\n  display: flex;\n  align-items: center;\n  padding-right: 10px;\n}\n\n/* Mobile Responsive Styles */\n@media (max-width: 768px) {\n\n  .hide-on-mobile {\n    display: none;\n  }\n\n  .recipe-actions,\n  .item-actions {\n    visibility: visible;\n  }\n\n  .header-user-info,\n  .tour-buttons {\n    display: none;\n  }\n\n  .hamburger-menu-icon {\n    display: block;\n  }\n\n  .App {\n    flex-direction: column;\n  }\n\n  .left-panel,\n  .right-panel {\n    width: 100%;\n    border-right: none;\n    padding: 0.5rem;\n  }\n\n  .left-panel {\n    border-bottom: 1px solid var(--border-color);\n    margin-bottom: 1rem;\n  }\n\n  .recipe-actions,\n  .item-actions,\n  .move-recipe-buttons {\n    visibility: visible;\n  }\n\n  .ingredients-container {\n    flex-direction: column;\n  }\n\n  .day-row {\n    display: block;\n  }\n\n  .empty-row-actions {\n    visibility: hidden;\n  }\n\n  .section-header .plus-button {\n    margin-left: 20px;\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.spin {\n  animation: spin 1s linear infinite;\n}\n\n/* Mobile View Button */\n.mobile-view-button {\n  display: none;\n  padding: 0;\n  margin-right: 5px;\n  color: #aaa;\n}\n\n.mobile-view-button:hover {\n  color: #fff;\n}\n\n@media (max-width: 768px) {\n  .mobile-view-button {\n    display: inline-flex;\n  }\n}\n\n/* Tooltip Overlay */\n.tooltip-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n}\n\n.recipe-tooltip.mobile-centered {\n  position: relative;\n  width: 90%;\n  max-width: 400px;\n  background-color: #333;\n  border: 1px solid #555;\n  border-radius: 5px;\n  padding: 20px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n}\n\n.tooltip-header {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 10px;\n}\n\n.close-tooltip-button {\n  color: #aaa;\n  padding: 0;\n}\n\n.close-tooltip-button:hover {\n  color: #fff;\n}\n\n/* Light Theme Overrides for Mobile Tooltip */\n.light-theme .recipe-tooltip.mobile-centered {\n  background-color: #f8f9fa;\n  border-color: #dee2e6;\n  color: #212529;\n}\n\n.light-theme .close-tooltip-button {\n  color: #6c757d;\n}\n\n.light-theme .close-tooltip-button:hover {\n  color: #343a40;\n}\n\n.dropdown-item-with-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.dropdown-item-actions {\n  display: flex;\n  visibility: hidden;\n  gap: 2px;\n}\n\n.dropdown-item-with-actions:hover .dropdown-item-actions {\n  visibility: visible;\n}\n\n.icon-button.small {\n  padding: 2px;\n  width: 24px;\n  height: 24px;\n}\n\n.icon-button.small i {\n  font-size: 18px;\n}\n\n.icon-button.active-green {\n  color: #4CAF50;\n}\n\n.icon-button.active-blue {\n  color: #2196F3;\n}\n\n.icon-button.active-red {\n  color: #f44336;\n}\n\n.filter-modal-container {\n  width: 700px;\n}\n\n.filter-modal-container ul {\n  min-width: 250px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
